import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p391898440550809600',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
